// extracted by mini-css-extract-plugin
export default {"container":"ActivityStream_container__wDN9j"};